var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCircleProductGutters(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.75 11.977c0-3.47-1.875-6.657-4.875-8.438-3.047-1.734-6.75-1.734-9.75 0C7.078 5.32 5.25 8.508 5.25 11.977c0 3.515 1.828 6.703 4.875 8.484 3 1.734 6.703 1.734 9.75 0 3-1.781 4.875-4.969 4.875-8.484zm-21.75 0a11.91 11.91 0 016-10.36c3.703-2.156 8.25-2.156 12 0 3.703 2.156 6 6.094 6 10.36 0 4.312-2.297 8.25-6 10.406-3.75 2.156-8.297 2.156-12 0-3.75-2.156-6-6.094-6-10.406zm5.69-1.832c.598-.17 1.221.175 1.392.773l1.267 4.434h7.302l1.267-4.434a1.125 1.125 0 112.164.618l-1.733 6.066H9.65l-1.733-6.066c-.17-.598.176-1.22.773-1.391zm3.732-2.153l1.969-3.187c.14-.188.375-.328.609-.328.234 0 .422.14.563.328l1.968 3.187c.282.516.469 1.078.469 1.64v.095c0 1.687-1.36 3-3 3-1.688 0-3-1.313-3-3v-.094c0-.563.14-1.125.422-1.64z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCircleProductGutters);
export default ForwardRef;
